// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3985":"79417829","6062":"929dc313","8428":"79417829"}[chunkId] + ".chunk.css";
};